import { ProcedureStatus } from '@core/models/procedure-status.enum';
import { ProcedureStep } from '@core/models/procedures.model';
import { FlowchartMode } from '@flowchart';
import { Dictionary } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { WithProp } from '@utils';

import { procedureFK, procedureLinksAdapter, procedureStepsAdapter } from './procedure.reducer';

const selectFeature = (state: any) => state[procedureFK];

const procedure = createSelector(selectFeature, (state => state.procedure));

const selectSteps = createSelector(selectFeature, (state => state.steps));
const stepsSelectors = procedureStepsAdapter.getSelectors(selectSteps);
const steps = {
  ...stepsSelectors,
  selectById: createSelector(
    stepsSelectors.selectEntities,
    (entities: Dictionary<ProcedureStep>, props: { id: number }) => entities[props.id] as ProcedureStep
  )
};

const selectLinks = createSelector(selectFeature, (state => state.links));
const links = procedureLinksAdapter.getSelectors(selectLinks);

const flowchartMode = createSelector(procedure,
  p => (p.status === ProcedureStatus.draft ? 'edit' : 'view') as FlowchartMode
);

export const procedureSelectors = {
  procedure,
  steps,
  links,
  flowchartMode,
};
